import assertEventType from 'common/bento/lib/assertEventType';
import { MachineGuards } from 'common/bento/types/MachineConfig';

import { Model } from './model';

export enum Guard {
  HasActivityOutsideEU = 'hasActivityOutsideEU',
  HasSanctionedMember = 'hasSanctionedMember',
  HasSanctions = 'hasSanctions',
}

const guards: MachineGuards<Model, Guard> = {
  hasActivityOutsideEU: (context, event) => {
    assertEventType(event, 'SUBMIT_ACTIVITY_OUTSIDE_EU');

    return event.data.hasActivityOutsideEU;
  },
  hasSanctionedMember: ({ getModuleData }) => {
    const { hasClientUnderSanctions } = getModuleData().viewer.company.profile;

    return Boolean(hasClientUnderSanctions);
  },
  hasSanctions: ({ getModuleData }) => {
    const {
      hasClientHelpingCountryUnderSanctions,
      hasClientInCountryUnderSanctions,
    } = getModuleData().viewer.company.profile;

    return Boolean(
      hasClientHelpingCountryUnderSanctions || hasClientInCountryUnderSanctions,
    );
  },
};

export default guards;
